import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'cocktail-mixer',
  name: 'Cocktail Recipe Mixer',
  description: 'Mix standard and custom cocktail drink recipes with visual ingredient checklists and glassware suggestions.',
  category: 'Explore',
  icon: 'GlassWater',
  route: '/tools/cocktail-mixer',
  metaTitle: 'Cocktail Recipe Mixer — Bartender Drink Guide Online',
  metaDescription: 'Find random drink recipes and bartending inspiration with our free online cocktail mixer. Get ingredient checklists, glassware tips, and mocktail options.',
  keywords: [
    'cocktail recipe mixer',
    'drink generator online',
    'bartender recipes list',
    'random cocktail finder',
    'mocktail recipe generator',
    'glassware suggest cocktails',
    'home bar helper'
  ],
  longDescription: 'The Cocktail Recipe Mixer is a bartending assistant that fetches random mixed drink recipes from open-source cocktail registries. Each result provides the drink title, glass classification, preparation steps, and interactive ingredient check-offs.',
  howToUse: [
    'Click the "Mix Drink" button to generate a random cocktail recipe.',
    'Filter by alcoholic vs non-alcoholic options depending on your preference.',
    'Review the required glassware under the "Glass Type" indicator.',
    'Check off ingredients under the bar checklist as you mix your drink.'
  ],
  benefits: [
    'Pulls live mixed drink records from open database registries.',
    'Includes non-alcoholic filter states (mocktails) for family-friendly events.',
    'Zero-auth required, loading fully client-side on mobile and desktop.'
  ],
  faq: [
    {
      question: 'What is the difference between a Cocktail and a Mocktail?',
      answer: 'Cocktails are mixed drinks that contain alcohol. Mocktails (non-alcoholic drinks) mimic the flavors of cocktails but omit any alcohol, making them suitable for all ages.'
    },
    {
      question: 'Does the generator suggest what glassware to use?',
      answer: 'Yes! The API provides the traditional glassware classification (e.g. Highball glass, Cocktail glass, Shot glass) recommended by professional mixologists for each recipe.'
    },
    {
      question: 'Can I search for drinks containing specific ingredients?',
      answer: 'This lightweight version is a random cocktail discovery board designed to suggest fun recipes. For custom ingredient search, stay tuned for future bar-cart expansion tools!'
    }
  ]
};
